<template>
  <div>
    <img @click="loginFb" class="cursor-pointer" src="@/assets/img/facebook.png" alt="facebook" />
  </div>
</template>

<script async defer crossorigin="anonymous" src="https://connect.facebook.net/zh_TW/sdk.js#xfbml=1&version=v11.0&appId=385484006659699&autoLogAppEvents=1" nonce="mIKK1Awi"></script>
<script>
import thirdpartyLoginKey from '@/thirdpartyLoginKey.js'; // @第三方登入: 統一賦予第三方登入註冊服務要用的應用 key 值
export default {
  name: 'Facebook',
  created() {
    this.initFbLogin();
  },
  methods: {
    // 初始化 FB 的 API
    initFbLogin() {
      window.fbAsyncInit = function() {
        FB.init({
          appId: thirdpartyLoginKey.FB_APP_ID, // 在 FB開發人員後台的 應用程式編號
          cookie: true,
          xfbml: true,
          version: 'v11.0'
        });
        FB.AppEvents.logPageView();
      };

      (function(d, s, id) {
        var js,
          fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
          return;
        }
        js = d.createElement(s);
        js.id = id;
        js.src = 'https://connect.facebook.net/en_US/sdk.js';
        fjs.parentNode.insertBefore(js, fjs);
      })(document, 'script', 'facebook-jssdk');
    },

    // 登入 FB
    loginFb() {
      /** FB 部分設定與密鑰需要登入 FB開發人員後台才可做設定
       * 要先登入帳號為 service@tiota.org.tw 的 FB，帳密請觀看 wiki: https://qms.flowring.com:9080/pages/viewpage.action?pageId=49578354
       * 登入後在點擊此連結到達開發人員後台 https://developers.facebook.com/apps
       */

      let appId = thirdpartyLoginKey.FB_APP_ID; // 在 FB開發人員後台的 應用程式編號
      let redirectUri = thirdpartyLoginKey.REDIRECT_URI; // FB 登入完後要導向哪頁
      let state = 'fb'; // 需要在 redirectUri 後方帶入 ? 的參數寫在此，因為 Line 的方式也一樣，所以 state 帶 'fb' 與 line 做出區別
      let fbLoginUrl = `https://www.facebook.com/v11.0/dialog/oauth?client_id=${appId}&redirect_uri=${redirectUri}&state=${state}`;
      location.href = fbLoginUrl;
    }
  }
};
</script>

<style></style>
